export default "__VITE_ASSET__BIqqw3tk__"